import { getId } from "@lib/store/actions/toasts"
import React, { FC, useEffect, useState } from "react"

type LogoProps = {
  variant?: "full" | "icon-only"
}

export const Logo: FC<LogoProps> = ({ variant = "icon-only" }) => {
  const [id, setId] = useState("")

  useEffect(() => {
    setId(getId())
  }, [])
  return (
    <>
      {variant === "full" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="147"
          height="21"
          fill="none"
          viewBox="0 0 147 21"
        >
          <g clipPath="url(#clip0_7955_61462)">
            <path
              fill={`url(#paint0_linear_7955_61462-${id})`}
              fillRule="evenodd"
              d="M16.91.021a.503.503 0 01.288 0l16.734 5.085a.226.226 0 01.161.218.228.228 0 01-.161.218L17.19 10.627a.502.502 0 01-.289 0L.162 5.542A.227.227 0 010 5.324a.229.229 0 01.161-.218L16.91.02zm14.204 9.414l-2.14-.649-11.776 3.584a.502.502 0 01-.288 0L5.132 8.794l-2.14.65a.227.227 0 00-.158.217.229.229 0 00.158.217l13.918 4.226a.502.502 0 00.288 0l13.916-4.226a.225.225 0 00.162-.217.227.227 0 00-.162-.218v-.009zm-4.969 3.68l2.14.649a.227.227 0 01.16.218.228.228 0 01-.16.218l-11.087 3.366a.502.502 0 01-.288 0L5.824 14.2a.226.226 0 01-.162-.218.229.229 0 01.162-.218l2.137-.65 8.948 2.717a.504.504 0 00.29 0l8.946-2.717zm-2.83 4.327l2.14.65a.226.226 0 01.161.218.23.23 0 01-.161.218l-8.257 2.507a.502.502 0 01-.288 0l-8.257-2.507a.226.226 0 01-.161-.218.229.229 0 01.161-.218l2.14-.65L16.91 19.3c.093.03.194.03.288 0l6.117-1.857z"
              clipRule="evenodd"
            ></path>
            <path
              fill="#fff"
              d="M42.579 17.089L37.74 5.02h2.548l3.159 8.369c.158.454.296.929.434 1.404.119-.475.258-.95.415-1.405l3.26-8.368h2.447l-4.839 12.068H42.58zM52.236 3.733c.69 0 1.302.416 1.302 1.209 0 .792-.612 1.187-1.302 1.187-.69 0-1.304-.395-1.304-1.187 0-.793.612-1.209 1.304-1.209zm-1.107 13.36V7.69h2.231v9.397l-2.231.005zM64.063 15.803c-1.343 1.048-2.547 1.464-4.206 1.464-2.667 0-4.562-1.504-4.562-4.808 0-3.402 1.896-4.946 4.62-4.946 2.628-.02 4.207 1.584 4.247 4.53.008.325-.012.65-.06.971l-6.674.02c.178 1.76 1.146 2.472 2.528 2.472 1.264 0 2.191-.297 3.376-1.048l.73 1.345zm-1.861-4.333c-.118-1.503-.927-2.275-2.29-2.275-1.284 0-2.232.672-2.469 2.275h4.759zM72.1 9.907c-1.204-.398-2.342-.695-3.139-.695-.797 0-1.264.336-1.264.949 0 .753.85.871 2.172 1.287 2.134.653 3.042 1.147 3.042 2.986 0 1.782-1.323 2.83-3.556 2.83a7.457 7.457 0 01-4.148-1.286l.75-1.543c1.105.653 2.152 1.049 3.397 1.049.849 0 1.401-.318 1.401-.93 0-.95-.77-1.01-2.43-1.524-1.816-.574-2.724-1.226-2.724-2.691 0-1.82 1.185-2.868 3.317-2.868 1.107 0 2.37.276 3.753.81l-.57 1.626zM81.027 15.822c-1.107.832-2.054 1.445-3.357 1.445-2.054 0-3.061-1.148-3.061-3.7V7.692h2.252v5.344c0 1.523.354 2.195 1.579 2.195.987 0 1.916-.71 2.587-1.523V7.691h2.231v9.398h-2.231v-1.267zM91.907 9.907c-1.204-.398-2.35-.695-3.139-.695-.79 0-1.264.336-1.264.949 0 .753.85.871 2.172 1.287 2.132.653 3.04 1.147 3.04 2.986 0 1.782-1.323 2.83-3.555 2.83a7.457 7.457 0 01-4.149-1.286l.751-1.543c1.106.653 2.153 1.049 3.396 1.049.849 0 1.403-.318 1.403-.93 0-.95-.77-1.01-2.43-1.524-1.816-.574-2.724-1.226-2.724-2.691 0-1.82 1.185-2.868 3.317-2.868 1.105 0 2.37.276 3.751.81l-.569 1.626zM108.367 14.105c-1.394.731-2.569 1.067-4.123 1.067-2.231 0-3.586-1.542-3.586-4.09 0-2.728 1.295-4.15 3.765-4.15 1.096 0 2.311.217 3.586.69l.717-1.738c-1.255-.672-2.908-1.047-4.402-1.047-3.825 0-6.016 2.233-6.016 6.244 0 3.953 2.191 6.186 5.816 6.186 1.953 0 3.566-.475 5.06-1.443l-.817-1.72zM113.315 17.089V4.244h-2.251v12.845h2.251zM120.176 7.524c-2.928-.02-4.8 1.897-4.8 4.92 0 2.945 1.852 4.823 4.8 4.823 2.948 0 4.821-1.878 4.821-4.822 0-3.024-1.873-4.94-4.821-4.92zm0 7.885c-1.593 0-2.589-1.067-2.589-2.964 0-1.976 1.016-3.083 2.589-3.083 1.594 0 2.61 1.107 2.61 3.083 0 1.897-1.016 2.964-2.61 2.964zM133.437 17.089h2.251V7.702h-2.251v6.008c-.677.81-1.613 1.521-2.609 1.521-1.235 0-1.594-.672-1.594-2.193V7.702h-2.27v5.87c0 2.549 1.015 3.695 3.087 3.695 1.315 0 2.271-.613 3.386-1.443v1.265zM144.749 17.089H147V4.244h-2.251v4.624a4.747 4.747 0 00-3.366-1.344c-2.212 0-3.686 1.364-3.686 4.822 0 3.518 1.873 4.92 3.905 4.92 1.553 0 2.27-.533 3.147-1.343v1.166zm0-3.063c-.677.77-1.335 1.383-2.47 1.383-1.275 0-2.371-.85-2.371-3.083 0-2.154.897-2.925 2.231-2.925 1.016 0 1.873.514 2.61 1.404v3.22z"
            ></path>
          </g>
          <defs>
            <linearGradient
              id={`paint0_linear_7955_61462-${id}`}
              x1="1.784"
              x2="34.718"
              y1="2.256"
              y2="5.591"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#10C6FF"></stop>
              <stop offset="1" stopColor="#7636FF"></stop>
            </linearGradient>
            <clipPath id="clip0_7955_61462">
              <path fill="#fff" d="M0 0H147V21H0z"></path>
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="20"
          fill="none"
          viewBox="0 0 34 20"
        >
          <g clipPath="url(#clip0_6273_12535)">
            <path
              fill={`url(#paint0_linear_6273_12535-${id})`}
              fillRule="evenodd"
              d="M16.903.02a.526.526 0 01.289 0l16.727 4.843c.047.013.088.04.117.078a.21.21 0 010 .259.227.227 0 01-.117.078l-16.734 4.843a.527.527 0 01-.29 0L.162 5.278A.227.227 0 01.045 5.2a.211.211 0 010-.259.227.227 0 01.116-.078L16.903.02zm14.2 8.966l-2.14-.618-11.771 3.412a.527.527 0 01-.289 0L5.13 8.377l-2.139.619a.227.227 0 00-.115.078.21.21 0 000 .257.227.227 0 00.115.079l13.912 4.024a.527.527 0 00.289 0l13.91-4.024a.225.225 0 00.118-.078.21.21 0 000-.259.225.225 0 00-.118-.077v-.009zm-4.968 3.504l2.139.618a.227.227 0 01.116.079.21.21 0 010 .258.226.226 0 01-.116.079l-11.082 3.205a.527.527 0 01-.289 0L5.821 13.524a.227.227 0 01-.116-.079.211.211 0 010-.258.227.227 0 01.116-.079l2.137-.618 8.945 2.587a.525.525 0 00.289 0l8.943-2.587zm-2.828 4.122l2.138.618c.047.014.088.041.117.078a.21.21 0 010 .26.227.227 0 01-.117.078l-8.253 2.387a.527.527 0 01-.289 0L8.65 17.646a.227.227 0 01-.117-.079.21.21 0 010-.259.227.227 0 01.117-.078l2.138-.618 6.115 1.769a.5.5 0 00.289 0l6.115-1.77z"
              clipRule="evenodd"
            ></path>
          </g>
          <defs>
            <linearGradient
              id={`paint0_linear_6273_12535-${id}`}
              x1="1.783"
              x2="34.671"
              y1="2.149"
              y2="5.644"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#10C6FF"></stop>
              <stop offset="1" stopColor="#7636FF"></stop>
            </linearGradient>
            <clipPath id="clip0_6273_12535">
              <path fill="#fff" d="M0 0H34V20H0z"></path>
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  )
}
